import React from "react";
import numeral from "numeral";
import BookingRateRow from "./BookingRateRow";
import Carousel from "../Carousel/Carousel";

export default class BookingRoomType extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.inquiry_room_type_id == this.props.room_type.id ? false : true,
      ratesVisible: false,
      roomDetailsVisible: true,
      fullscreenImages: false,
    };

    this.fullScreenImages = React.createRef();

    this.onToggleCollapsed = this.onToggleCollapsed.bind(this);
    this.onToggleFullscreenImages = this.onToggleFullscreenImages.bind(this);
    this.onToggleRatesVisibility = this.onToggleRatesVisibility.bind(this);
  }

  componentDidMount() {
    var self = this;

    $(window).on("roomTypeCollapse", function (e, room_type_id) {
      if (room_type_id !== self.props.room_type.id) {
        setTimeout(() => {
          self.setState({ collapsed: true });
        }, 1);
      }
    });
  }

  componentWillUnmount() {
    $(window).off("roomTypeCollapse");
  }

  render() {
    return (
      <div className={this.props.finalRoomType ? "list-bottom" : ""}>
        {this.state.collapsed ? this.renderCollapsed() : this.renderExpanded()}
        {this.state.fullscreenImages ? this.renderFullscreenImages() : null}
      </div>
    );
  }

  renderArrow() {
    if (!this.state.collapsed) {
      return (
        <span className="bf-arrow-down" onClick={this.onToggleCollapsed}></span>
      );
    } else {
      return (
        <span
          className="bf-arrow-right"
          onClick={this.onToggleCollapsed}
        ></span>
      );
    }
  }

  renderBody() {
    if (this.state.collapsed) {
      return this.renderCollapsed();
    } else {
      return this.renderExpanded();
    }
  }

  renderCollapsed() {
    if (this.props.room_type.images && this.props.room_type.images.length > 0) {
      var image = <img src={this.props.room_type.images[0].thumbnail_url} />;
    } else {
      var image = (
        <img src={this.props.default_hotel_room_icon_path} width="100%" />
      );
    }

    const rate = this.props.room_type.available_rates[0];
    const average_subtotal = rate.average_amount;

    return (
      <div
        className="BookingRoomType collapsed"
        onClick={this.onToggleCollapsed}
      >
        <div className="left-side">{image}</div>
        <div className="right-side">
          <h2 className="name">{this.props.room_type.name}</h2>
          <p
            className="description"
            dangerouslySetInnerHTML={{
              __html: this.props.room_type.description,
            }}
          ></p>
          <div className="inline-details">
            <ul>
              {this.props.room_type.maximum_occupancy ? (
                <li>
                  <span className="dot">&#183;</span>{" "}
                  {this.props.room_type.maximum_occupancy} {I18n.t("max_guests")}
                </li>
              ) : null}
              {
              this.props.room_type.bed_types 
              ? 
                this.props.room_type.bed_types.map(bt => {
                return (
                  <li key={bt.id}>
                    <span className="dot">&#183;</span>{" "}
                    {`${bt.count} ${bt.name}`} 
                  </li>
                )
              })
              : 
                null
              }
              {this.props.room_type.room_size && this.props.room_type.room_size_unit ? (
                <li>
                  <span className="dot">&#183;</span>{" "}
                  {`${this.props.room_type.room_size} ${I18n.t(this.props.room_type.room_size_unit)}`}
                </li>
              ) : null}
            </ul>
          </div>
          {rate ? (
            <div className="white-booking-button">
              <div className="subtotal">
                {this.props.currency.symbol}
                {numeral(average_subtotal / 100).format(
                  this.props.number_format_no_decimals
                )}
              </div>
              <div className="with-taxes-and-fees">
                {I18n.t("excludes_taxes_and_fees")}
              </div>
            </div>
          ) : null}
        </div>
        {this.renderArrow()}
      </div>
    );
  }

  renderExpanded() {
    const rate = this.props.room_type.available_rates[0];
    if (this.props.room_type.images && this.props.room_type.images.length > 0) {
      var images = this.props.room_type.images.map((image, idx) => {
        return (
          <div key={image.id} className="image-wrapper">
            <img
              src={image.max_url}
              key={image.id}
              onClick={this.onToggleFullscreenImages.bind(this, idx)}
            />
          </div>
        );
      });
    } else {
      var images = []
    }

    return (
      <div className="BookingRoomType">
        <div className="row">
          <div className="col-md-12">
            <h2 className="name">{this.props.room_type.name}</h2>
            {this.renderArrow()}
          </div>
        </div>
        <div className="row">
          <div className="col-md-7">
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: this.props.room_type.description,
              }}
            ></p>
          </div>
          <div className="col-md-5">{this.renderRoomDetails()}</div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="images-wrapper">
              <div className="images">
                <Carousel settings={{draggable: false, initialSlide: this.state.imageIndex || 0}} dontAnimate={true} displayArray={images} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BookingRateRow
              currency={this.props.currency}
              room_type={this.props.room_type}
              rate={rate}
              start_date={this.props.start_date}
              end_date={this.props.end_date}
              guests={this.props.guests}
              onAddReservationSegment={this.props.onAddReservationSegment}
            />
            {this.renderRates()}
            {/*this.props.room_type.available_rates &&
            this.props.room_type.available_rates.length > 1 ? (
              <div
                className="RatesToggle"
                style={{ borderTop: 0, paddingTop: 0 }}
              >
                <a href="#" onClick={this.onToggleRatesVisibility}>
                  {this.state.ratesVisible
                    ? I18n.t("view_less_rates")
                    : I18n.t("view_more_rates")}
                </a>
              </div>
                  ) : null
            */}
          </div>
        </div>
      </div>
    );
  }

  renderFullscreenImages() {
    if (this.props.room_type.images && this.props.room_type.images.length > 0) {
      const height = this.props.bookingFlowRef.current.offsetHeight;
      var images = this.props.room_type.images.map((image) => {
        const { dimensions = '690x420' } = image;
        const [i_width, i_height] = dimensions.split('x').map(d => parseInt(d));
        return (
          <div key={image.id}>
            <div className="image-wrapper" style={{height: `${height}px`}}>
              <img
                src={image.max_url}
                key={image.id}
                style={{height: i_width >= i_height ? 'auto' : '100%', width: i_width >= i_height ? '100%' : 'auto'}}
              />
            </div>
          </div>
        );
      });
    } else {
      var images = []
    }

    return (
      <div className="fullscreen-images">
        <div className="overlay"></div>
        <a
          href="#"
          className="close-button"
          onClick={this.onToggleFullscreenImages.bind(this, null)}
        >
          {I18n.t("hide_photos")}
        </a>
        <div>
          <div className="images-wrapper">
            <div className="images">
              <Carousel settings={{draggable: false, initialSlide: this.state.imageIndex || 0, afterChange: (idx) => {
                this.setState({imageIndex: idx});
              }}} displayArray={images} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRates() {
    if (
      this.props.room_type.available_rates &&
      this.props.room_type.available_rates.length > 1
    ) {
      var rates = this.props.room_type.available_rates
        .map((rate) => {
          if (rate.id != this.props.room_type.available_rates[0].id) {
            return (
              <BookingRateRow
                key={rate.id}
                currency={this.props.currency}
                room_type={this.props.room_type}
                rate={rate}
                start_date={this.props.start_date}
                end_date={this.props.end_date}
                onAddReservationSegment={this.props.onAddReservationSegment}
                guests={this.props.guests}
              />
            );
          }
        });

      return (
        <div className="rates">{rates}</div>
      );
    }
  }

  renderRoomDetails() {
    var amenities = this.props.room_type.amenities
      .sort((a, b) => a.position - b.position)
      .map(function (amenity) {
        return <li key={amenity.id}>{amenity.name}</li>;
      });

    var bed_types = this.props.room_type.bed_types
      .sort((a, b) => a.position - b.position)
      .map(function (bed_type) {
        return <li key={bed_type.id}>{`${bed_type.count} ${bed_type.name}`}</li>;
      });
    return (
      <div>
        {this.state.roomDetailsVisible ? (
          <div className="RoomDetails">
            <div className="room-details">
            <h3>{I18n.t("details")}</h3>

              <ul style={{ marginBottom: 0 }}>
                {this.props.room_type.maximum_occupancy ? (
                  <li>
                    {this.props.room_type.maximum_occupancy} {I18n.t("max_guests")}
                  </li>
                ) : null}
                {this.props.room_type.room_size && this.props.room_type.room_size_unit ? (
                  <li>
                    {`${this.props.room_type.room_size} ${I18n.t(this.props.room_type.room_size_unit)}`}
                  </li>
                ) : null}
              </ul>
            </div>
            {amenities && amenities.length ? (
              <div className="room-amenities">
                <h3>{I18n.t("amenities")}</h3>
                <ul>{amenities}</ul>
              </div>
            ) : null}
            {bed_types && bed_types.length ? (
              <div className="room-bed-types">
                <h3>{I18n.t("bed_types")}</h3>
                <ul>{bed_types}</ul>
              </div>
            ) : null}
            
          </div>
        ) : null}
      </div>
    );
  }

  /**
   * Change handlers
   */

  onToggleCollapsed(e) {
    var self = this;
    e.preventDefault();
    this.setState(
      { collapsed: this.state.collapsed ? false : true },
      function () {
        if (self.state.collapsed) {
          $(window).trigger("roomTypeCollapse", null);
        } else {
          $(window).trigger("roomTypeCollapse", self.props.room_type.id);
        }
      }
    );
  }

  onToggleFullscreenImages(idx, e) {
    e.preventDefault();
    this.setState({ imageIndex: idx !== null ? idx : this.state.imageIndex, fullscreenImages: !this.state.fullscreenImages }, () => {
      if (typeof this.props.onModalVisible === "function") {
        this.props.onModalVisible(this.state.fullscreenImages);
      }
    });
  }

  onToggleRatesVisibility(e) {
    e.preventDefault();
    this.setState({ ratesVisible: this.state.ratesVisible ? false : true });
  }

}
